import { Award, Download } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { TrainingProgress, EnrichedTrainingProgress } from '@/hooks/use-training-progress';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';


interface CertificateSectionProps {
  progress: TrainingProgress | EnrichedTrainingProgress;
}

export function CertificateSection({ progress }: CertificateSectionProps) {
  const allDone = progress.completed_modules === progress.total_modules;

  if (!allDone) return null;

  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Award className="h-5 w-5 text-primary" />
          Certificate of Completion
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          You have completed all {progress.total_modules} training modules. View and download your
          certificate.
        </p>
        <Button asChild>
          <Link to="/certificate">
            <Download className="mr-2 h-4 w-4" />
            View Certificate
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
